//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// 导入路由前缀配置
import { roterPre } from '@/settings';
export default {
  name: 'PagesHeader',
  props: {
    // 页面标题，默认为空字符串
    title: {
      type: String,
      default: ''
    },
    // 返回的路由地址，默认为空字符串
    backUrl: {
      type: String,
      default: ''
    }
  },
  data: function data() {
    return {
      // 这里可以添加组件内部的数据
    };
  },
  methods: {
    /**
     * 点击返回按钮时触发的方法
     * 如果 backUrl 存在，则跳转到指定的路由地址
     * 否则返回上一页
     */
    goBack: function goBack() {
      if (this.backUrl) {
        this.$router.push({
          path: "".concat(roterPre).concat(this.backUrl)
        });
      } else {
        this.$router.back();
      }
    }
  }
};